import apiDataResponseHandler from 'util/promiseFactory/apiDataResponseHandler';
import { getJobGroupAutosuggestJF } from 'app/services/partner/autosuggest';
import withInputErrorMessage from '../withInputErrorMessage';
import autosuggestFactory from './autosuggestFactory';
import withAutosuggestWrapper from './withAutosuggestWrapper';

const JobGroupAutosuggestJF = autosuggestFactory({
   apiPromise: getJobGroupAutosuggestJF,
   handleApiDataResponse: apiDataResponseHandler.withSuggestionsFromDataPropAndNameAsLabel,
   defaultPlaceholder: 'Search Job Group...',
});

export default withAutosuggestWrapper(withInputErrorMessage(JobGroupAutosuggestJF));
